"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var CognitoService_1;
Object.defineProperty(exports, "__esModule", { value: true });
const common_1 = require("@affinidi/common");
let fetch;
/* istanbul ignore next */
if (!fetch) {
    ;
    global.fetch = require('node-fetch');
}
const AWS = require('aws-sdk');
const WalletStorageService_1 = __importDefault(require("./WalletStorageService"));
const SdkError_1 = __importDefault(require("../shared/SdkError"));
const sessionStorageHandler_1 = require("../shared/sessionStorageHandler");
const _defaultConfig_1 = require("../_defaultConfig");
const validateUsername_1 = require("../shared/validateUsername");
const normalizeUsername_1 = require("../shared/normalizeUsername");
const tempSession = {};
let CognitoService = CognitoService_1 = class CognitoService {
    constructor(options = {}) {
        this.cognitoOptionKeys = ['clientId', 'userPoolId'];
        this.authenticationFlowType = 'USER_PASSWORD_AUTH';
        this.cognitoidentityserviceprovider = new AWS.CognitoIdentityServiceProvider({
            region: _defaultConfig_1.DEFAULT_COGNITO_REGION,
            apiVersion: '2016-04-18',
        });
        this._validateCognitoOptions(options);
        this.cognitoOptions = {
            region: options.region || _defaultConfig_1.DEFAULT_COGNITO_REGION,
            clientId: options.clientId || _defaultConfig_1.STAGING_COGNITO_CLIENT_ID,
            userPoolId: options.userPoolId || _defaultConfig_1.STAGING_COGNITO_USER_POOL_ID,
        };
    }
    refreshUserSessionTokens(refreshToken) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const response = yield this._signInWithRefreshToken(refreshToken);
                return response;
            }
            catch (error) {
                throw new SdkError_1.default('COR-9');
            }
        });
    }
    signIn(username, password) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const response = yield this._signIn(username, password);
                return response;
            }
            catch (error) {
                switch (error.code) {
                    case 'COR-4':
                    case 'UserNotFoundException':
                        throw new SdkError_1.default('COR-4', { username });
                    case 'UserNotConfirmedException':
                        throw new SdkError_1.default('COR-16', { username });
                    default:
                        throw error;
                }
            }
        });
    }
    signInWithUsername(username, messageParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            this._usernameShouldBeEmailOrPhoneNumber(username);
            try {
                const token = yield this._signInWithUsername(username, messageParameters);
                return token;
            }
            catch (error) {
                if (error.code === 'UserNotFoundException') {
                    throw new SdkError_1.default('COR-4', { username });
                }
                else {
                    throw error;
                }
            }
        });
    }
    static setTempSession(ChallengeParameters, Session) {
        const { USERNAME } = ChallengeParameters;
        tempSession[USERNAME] = Session;
    }
    completeLoginChallenge(token, confirmationCode) {
        return __awaiter(this, void 0, void 0, function* () {
            const { Session: tokenSession, ChallengeName, ChallengeParameters } = JSON.parse(token);
            let Session = tokenSession;
            const { USERNAME } = ChallengeParameters;
            if (tempSession[USERNAME]) {
                Session = tempSession[USERNAME];
            }
            const { clientId: ClientId } = this.cognitoOptions;
            const params = {
                ClientId,
                ChallengeName,
                ChallengeResponses: Object.assign(Object.assign({}, ChallengeParameters), { ANSWER: confirmationCode }),
                Session,
            };
            try {
                // prettier-ignore
                const result = yield this.cognitoidentityserviceprovider
                    .respondToAuthChallenge(params)
                    .promise();
                CognitoService_1.setTempSession(ChallengeParameters, result.Session);
                // NOTE: respondToAuthChallenge for the custom auth flow do not return
                //       error, but if response has `ChallengeName` - it is an error
                if (result.ChallengeName === 'CUSTOM_CHALLENGE') {
                    throw new SdkError_1.default('COR-5');
                }
                const cognitoUserTokens = this._normalizeTokensFromCognitoAuthenticationResult(result.AuthenticationResult);
                const { userPoolId } = this.cognitoOptions;
                sessionStorageHandler_1.saveUserTokensToSessionStorage(userPoolId, cognitoUserTokens);
                return cognitoUserTokens;
            }
            catch (error) {
                // NOTE: Incorrect username or password. -> Corresponds to custom auth challenge
                //       error when OTP was entered incorrectly 3 times.
                if (error.message === 'Incorrect username or password.') {
                    throw new SdkError_1.default('COR-13');
                }
                else if (error.code === 'NotAuthorizedException') {
                    // Throw when OTP is expired (3 min)
                    throw new SdkError_1.default('COR-17', { confirmationCode });
                }
                else {
                    throw error;
                }
            }
        });
    }
    // NOTE: Signs out users from all devices. It also invalidates all
    //       refresh tokens issued to a user. The user's current access and
    //       Id tokens remain valid until their expiry.
    //       Access and Id tokens expire one hour after they are issued.
    signOut(AccessToken) {
        return __awaiter(this, void 0, void 0, function* () {
            this.cognitoidentityserviceprovider.globalSignOut({ AccessToken });
        });
    }
    forgotPassword(Username, messageParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            this._usernameShouldBeEmailOrPhoneNumber(Username);
            const { clientId: ClientId } = this.cognitoOptions;
            const params = {
                ClientId,
                Username,
            };
            if (messageParameters) {
                Object.assign(params, { ClientMetadata: messageParameters });
            }
            try {
                const response = yield this.cognitoidentityserviceprovider.forgotPassword(params).promise();
                return response;
            }
            catch (error) {
                if (error.code === 'UserNotFoundException') {
                    throw new SdkError_1.default('COR-4', { username: Username });
                }
                else {
                    throw error;
                }
            }
        });
    }
    forgotPasswordSubmit(username, ConfirmationCode, Password) {
        return __awaiter(this, void 0, void 0, function* () {
            this._usernameShouldBeEmailOrPhoneNumber(username);
            const { clientId: ClientId } = this.cognitoOptions;
            const params = {
                ClientId,
                Password,
                Username: username,
                ConfirmationCode,
            };
            try {
                const response = yield this.cognitoidentityserviceprovider.confirmForgotPassword(params).promise();
                return response;
            }
            catch (error) {
                switch (error.code) {
                    case 'ExpiredCodeException':
                        throw new SdkError_1.default('COR-2', { username, confirmationCode: ConfirmationCode });
                    case 'UserNotFoundException':
                        throw new SdkError_1.default('COR-4', { username });
                    case 'CodeMismatchException':
                        throw new SdkError_1.default('COR-5', { username, confirmationCode: ConfirmationCode });
                    case 'InvalidPasswordException':
                        throw new SdkError_1.default('COR-6');
                    default:
                        throw error;
                }
            }
        });
    }
    signUp(Username, Password, messageParameters, options = {}) {
        return __awaiter(this, void 0, void 0, function* () {
            const UserAttributes = this._buildUserAttributes(Username);
            const normalizedUsername = normalizeUsername_1.normalizeUsername(Username);
            const { clientId: ClientId } = this.cognitoOptions;
            const ClientMetadata = messageParameters || {};
            const params = { ClientId, Password, Username: normalizedUsername, UserAttributes, ClientMetadata };
            try {
                const response = yield this.cognitoidentityserviceprovider.signUp(params).promise();
                return response;
            }
            catch (error) {
                switch (error.code) {
                    case 'UsernameExistsException': {
                        const isUserUnconfirmed = yield this.isUserUnconfirmed(normalizedUsername);
                        if (isUserUnconfirmed) {
                            // NOTE: this will remove unconfirmed user so we won't get here 2nd time
                            yield WalletStorageService_1.default.adminDeleteUnconfirmedUser(normalizedUsername, options);
                            yield this.signUp(Username, Password, messageParameters, options);
                            break;
                        }
                        throw new SdkError_1.default('COR-7', { username: normalizedUsername });
                    }
                    case 'InvalidPasswordException':
                        throw new SdkError_1.default('COR-6');
                    default:
                        throw error;
                }
            }
        });
    }
    resendSignUp(Username, messageParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            Username = normalizeUsername_1.normalizeUsername(Username);
            const { clientId: ClientId } = this.cognitoOptions;
            const params = { ClientId, Username };
            if (messageParameters) {
                Object.assign(params, { ClientMetadata: messageParameters });
            }
            try {
                const response = yield this.cognitoidentityserviceprovider.resendConfirmationCode(params).promise();
                return response;
            }
            catch (error) {
                switch (error.code) {
                    case 'UserNotFoundException':
                        throw new SdkError_1.default('COR-4', { username: Username });
                    case 'InvalidParameterException':
                        throw new SdkError_1.default('COR-8', { username: Username });
                    default:
                        throw error;
                }
            }
        });
    }
    confirmSignUp(Username, ConfirmationCode) {
        return __awaiter(this, void 0, void 0, function* () {
            Username = normalizeUsername_1.normalizeUsername(Username);
            const { clientId: ClientId } = this.cognitoOptions;
            const params = { ClientId, Username, ConfirmationCode };
            try {
                const response = yield this.cognitoidentityserviceprovider.confirmSignUp(params).promise();
                return response;
            }
            catch (error) {
                switch (error.code) {
                    case 'UserNotFoundException':
                        throw new SdkError_1.default('COR-4', { username: Username });
                    case 'ExpiredCodeException':
                        throw new SdkError_1.default('COR-2', { username: Username, confirmationCode: ConfirmationCode });
                    case 'CodeMismatchException':
                        throw new SdkError_1.default('COR-5', { username: Username, confirmationCode: ConfirmationCode });
                    default:
                        throw error;
                }
            }
        });
    }
    changePassword(AccessToken, PreviousPassword, ProposedPassword) {
        return __awaiter(this, void 0, void 0, function* () {
            const params = { AccessToken, PreviousPassword, ProposedPassword };
            return this.cognitoidentityserviceprovider.changePassword(params).promise();
        });
    }
    changeUsername(AccessToken, attribute) {
        return __awaiter(this, void 0, void 0, function* () {
            const userExists = yield this._userExists(attribute);
            if (userExists) {
                throw new SdkError_1.default('COR-7', { username: attribute });
            }
            const UserAttributes = this._buildUserAttributes(attribute);
            const params = { AccessToken, UserAttributes };
            return this.cognitoidentityserviceprovider.updateUserAttributes(params).promise();
        });
    }
    confirmChangeUsername(AccessToken, attribute, confirmationCode) {
        return __awaiter(this, void 0, void 0, function* () {
            const Code = confirmationCode;
            const { isPhoneNumberValid } = validateUsername_1.validateUsername(attribute);
            let AttributeName = 'email';
            if (isPhoneNumberValid) {
                AttributeName = 'phone_number';
            }
            const params = { AccessToken, AttributeName, Code };
            try {
                const response = yield this.cognitoidentityserviceprovider.verifyUserAttribute(params).promise();
                return response;
            }
            catch (error) {
                switch (error.code) {
                    case 'ExpiredCodeException':
                        throw new SdkError_1.default('COR-2', { attribute: AttributeName, confirmationCode });
                    case 'CodeMismatchException':
                        throw new SdkError_1.default('COR-5', { attribute: AttributeName, confirmationCode });
                    default:
                        throw error;
                }
            }
        });
    }
    isUserUnconfirmed(username) {
        return __awaiter(this, void 0, void 0, function* () {
            const { isUnconfirmed } = yield this._signInWithInvalidPassword(username);
            return isUnconfirmed;
        });
    }
    /* istanbul ignore next: private function */
    _validateCognitoOptions(options = {}) {
        const optionKeys = Object.keys(options);
        if (optionKeys.length > 0) {
            optionKeys.every((value) => {
                if (!this.cognitoOptionKeys.includes(value)) {
                    throw new Error(`All or none Cognito parameters must be provided: ${this.cognitoOptionKeys}`);
                }
            });
        }
    }
    /* istanbul ignore next: private function */
    _usernameShouldBeEmailOrPhoneNumber(username) {
        const { isEmailValid, isPhoneNumberValid } = validateUsername_1.validateUsername(username);
        if (!isEmailValid && !isPhoneNumberValid) {
            throw new SdkError_1.default('COR-3', { username });
        }
    }
    /* istanbul ignore next: private method */
    _getCognitoAuthParametersObject(AuthFlow, username = null, password = null, refreshToken = null) {
        let AuthParameters = {};
        switch (AuthFlow) {
            case 'USER_PASSWORD_AUTH':
                AuthParameters = {
                    USERNAME: username,
                    PASSWORD: password,
                };
                break;
            case 'CUSTOM_AUTH':
                AuthParameters = {
                    USERNAME: username,
                };
                break;
            case 'REFRESH_TOKEN_AUTH':
                AuthParameters = {
                    REFRESH_TOKEN: refreshToken,
                };
        }
        const { clientId: ClientId } = this.cognitoOptions;
        return { AuthFlow, ClientId, AuthParameters };
    }
    /* istanbul ignore next: private method */
    _signIn(attribute, password) {
        return __awaiter(this, void 0, void 0, function* () {
            const username = attribute;
            const authFlow = 'USER_PASSWORD_AUTH';
            try {
                const params = this._getCognitoAuthParametersObject(authFlow, username, password);
                const { AuthenticationResult } = yield this.cognitoidentityserviceprovider.initiateAuth(params).promise();
                const cognitoUserTokens = this._normalizeTokensFromCognitoAuthenticationResult(AuthenticationResult);
                const { userPoolId } = this.cognitoOptions;
                sessionStorageHandler_1.saveUserTokensToSessionStorage(userPoolId, cognitoUserTokens);
                return cognitoUserTokens;
            }
            catch (error) {
                if (error.code === 'UserNotFoundException') {
                    throw new SdkError_1.default('COR-4', { username });
                }
                throw error;
            }
        });
    }
    /* istanbul ignore next: private method */
    _normalizeTokensFromCognitoAuthenticationResult(AuthenticationResult) {
        const { AccessToken: accessToken, IdToken: idToken, RefreshToken: refreshToken, ExpiresIn } = AuthenticationResult;
        // NOTE: ExpiresIn = 3600, in seconds which is 1h
        const expiresIn = Date.now() + ExpiresIn * 1000;
        return { accessToken, idToken, refreshToken, expiresIn };
    }
    /* istanbul ignore next: private method */
    _signInWithUsername(username, messageParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const authFlow = 'CUSTOM_AUTH';
            const params = this._getCognitoAuthParametersObject(authFlow, username);
            if (messageParameters) {
                Object.assign(params, { ClientMetadata: messageParameters });
            }
            const response = yield this.cognitoidentityserviceprovider.initiateAuth(params).promise();
            const token = JSON.stringify(response);
            // prettier-ignore
            return token;
        });
    }
    /* istanbul ignore next: private method */
    _signInWithRefreshToken(token) {
        return __awaiter(this, void 0, void 0, function* () {
            const authFlow = 'REFRESH_TOKEN_AUTH';
            const params = this._getCognitoAuthParametersObject(authFlow, token);
            const { AuthenticationResult } = yield this.cognitoidentityserviceprovider.initiateAuth(params).promise();
            const cognitoUserTokens = this._normalizeTokensFromCognitoAuthenticationResult(AuthenticationResult);
            const { userPoolId } = this.cognitoOptions;
            sessionStorageHandler_1.saveUserTokensToSessionStorage(userPoolId, cognitoUserTokens);
            return cognitoUserTokens;
        });
    }
    /* istanbul ignore next: private function */
    _buildUserAttributes(username) {
        const { isEmailValid, isPhoneNumberValid } = validateUsername_1.validateUsername(username);
        const attributes = [];
        if (isEmailValid) {
            attributes.push({
                Name: 'email',
                Value: username,
            });
        }
        if (isPhoneNumberValid) {
            attributes.push({
                Name: 'phone_number',
                Value: username,
            });
        }
        return attributes;
    }
    /* istanbul ignore next: private function */
    _signInWithInvalidPassword(username) {
        return __awaiter(this, void 0, void 0, function* () {
            let errorCode;
            let userExists = true;
            let isUnconfirmed = false;
            const { userPoolId, clientId } = this.cognitoOptions;
            const invalidPassword = '1';
            const cognitoService = new CognitoService_1({ userPoolId, clientId });
            try {
                yield cognitoService.signIn(username, invalidPassword);
            }
            catch (error) {
                errorCode = error.code;
                if (errorCode === 'UserNotConfirmedException' || errorCode === 'COR-16') {
                    isUnconfirmed = true;
                }
                if (errorCode === 'UserNotFoundException' || errorCode === 'COR-4') {
                    userExists = false;
                }
            }
            return { isUnconfirmed, userExists, errorCode };
        });
    }
    /* istanbul ignore next: private function */
    _userExists(username) {
        return __awaiter(this, void 0, void 0, function* () {
            const { userExists } = yield this._signInWithInvalidPassword(username);
            return userExists;
        });
    }
};
CognitoService = CognitoService_1 = __decorate([
    common_1.profile()
], CognitoService);
exports.default = CognitoService;
//# sourceMappingURL=CognitoService.js.map